<template>
  <div class="ie-warning" v-if="isIEorEdge">
    <h2 style="font-weight: lighter"><span class="icon-warning"></span>
      {{ $t('vue2.IEWarning.you_are_using_a_IE_or_Edge_to_get') }}
      <span style="font-weight: bold;font-style: italic">{{ $t('vue2.IEWarning.a_faster_and_better_experience') }}</span>
      {{ $t('vue2.IEWarning.we_recommend_that_you_switch_to_these_browsers') }}:
      <a href="https://www.google.com/chrome/" class="text-blue" target="_blank">
        Google Chrome</a>
      {{ $t('vue2.IEWarning.or') }}
      <a href="https://www.mozilla.org/firefox/new/" target="_blank">Firefox</a>
    </h2>
  </div>
</template>

<script>
  export default {
    computed: {
      isIEorEdge () {
        // Internet Explorer 6-11
        const isIE = /* @cc_on!@*/false || !!document.documentMode
        // Edge 20+
        const isEdge = !isIE && !!window.StyleMedia
        // Chrome 1+
        // var isChrome = !!window.chrome && !!window.chrome.webstore
        return (isIE || isEdge)
      }
    }
  }
</script>

<style scoped>
  .ie-warning {
    background: #ffcece;
    padding: 10px;
    color: #994545;
    border: 1px solid #994545;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// IEAndEdgeWarning.vue?7090bfd9